import PageHero from "@/components/PageHero";
import { PRINCIPAL_MESSAGE, IMAGES } from "@/lib/site";
import { Quote, Award, Users, BookOpen } from "lucide-react";

export default function PrincipalPage() {
  const paragraphs = PRINCIPAL_MESSAGE.split("\n\n");

  return (
    <div data-testid="principal-page">
      <PageHero eyebrow="PRINCIPAL'S MESSAGE" title="From the Desk of the Principal" subtitle="A warm welcome to every parent and student who walks through our gates." />

      <section className="py-20 px-6 bg-white">
        <div className="max-w-6xl mx-auto grid md:grid-cols-5 gap-12 items-start">
          {/* Principal photo */}
          <div className="md:col-span-2 md:sticky md:top-28">
            <div className="relative">
              <div className="absolute -inset-3 bg-gold/20 rounded-3xl blur-2xl" />
              <img
                src={IMAGES.principal}
                alt="Principal, Royal English Medium High School"
                className="relative rounded-3xl shadow-2xl w-full aspect-[3/4] object-cover object-[center_top] border-4 border-white"
                data-testid="principal-photo"
              />
              <div className="absolute -bottom-4 left-1/2 -translate-x-1/2 bg-gold text-royal-dark px-6 py-2 rounded-full shadow-xl text-xs font-bold tracking-[0.25em] whitespace-nowrap">
                PRINCIPAL
              </div>
            </div>
            <div className="mt-10 text-center">
              <h3 className="font-serif-display text-2xl font-bold text-royal">Royal English Medium High School</h3>
              <p className="text-gold font-semibold tracking-wide mt-1">Principal's Office</p>
              <p className="text-gray-500 text-sm mt-1">Chikmagalur, Karnataka</p>
            </div>
          </div>

          {/* Message block */}
          <div className="md:col-span-3">
            <div className="bg-[#f7f7f7] border border-gray-100 rounded-3xl p-8 md:p-10 relative">
              <Quote className="text-gold absolute top-6 right-6" size={36} />
              <p className="text-xs tracking-[0.3em] text-gold font-bold">A MESSAGE TO OUR PARENTS & STUDENTS</p>
              <h2 className="font-serif-display text-3xl md:text-4xl font-bold text-royal mt-3 leading-tight">
                Nurturing Knowledge, Building Character.
              </h2>
              <div className="gold-divider" />
              <div className="space-y-4 mt-6 text-gray-700 leading-relaxed text-[15px] md:text-base">
                {paragraphs.map((p, i) => (
                  <p key={i}>{p}</p>
                ))}
              </div>
              <div className="mt-8 border-t border-gold/30 pt-5">
                <p className="font-serif-display text-2xl font-bold text-royal">— Principal</p>
                <p className="text-sm text-gray-600 italic">Royal English Medium High School, Chikmagalur</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-16 px-6 bg-[#f5f5f5]">
        <div className="max-w-7xl mx-auto grid md:grid-cols-3 gap-6">
          {[
            { icon: Award, n: "25+", l: "Years of Educational Leadership" },
            { icon: Users, n: "1000+", l: "Students Mentored" },
            { icon: BookOpen, n: "100%", l: "Board Exam Success Rate" },
          ].map((s, i) => (
            <div key={i} data-testid={`principal-stat-${i}`} className="bg-white rounded-2xl p-8 text-center border border-gray-100 hover-lift">
              <div className="w-14 h-14 mx-auto rounded-2xl bg-royal/5 text-royal flex items-center justify-center mb-4">
                <s.icon size={26} />
              </div>
              <p className="font-serif-display text-4xl font-bold text-royal">{s.n}</p>
              <p className="text-sm text-gray-600 mt-1">{s.l}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
